import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
export function useNavigateKeepSession() {
    const navigate = useNavigate();
    return useCallback((to) => {
        const sessionId = sessionStorage.getItem("sessionId");
        if (sessionId) {
            const sep = to.includes("?") ? "&" : "?";
            navigate(`${to}${sep}sessionId=${sessionId}`);
        }
        else {
            navigate(to);
        }
    }, [navigate]);
}
